<template>
  <div class="bottom-bar">
    <contact-store from="2" :prescriptionDetail="prescription"></contact-store>
    <div class="button-group">
      <el-button @click="reject">审核驳回</el-button>
      <el-button type="primary" @click="pass">审核通过</el-button>
    </div>
    <el-dialog
      class="reject-dialog"
      width="376px"
      title="驳回理由"
      :visible.sync="rejectDialogVisible"
      append-to-body
      @open="resetForm"
    >
      <el-form
        ref="rejectForm"
        :model="rejectForm"
        :rules="{ reason: [{ required: true, message: '请输入驳回理由', trigger: 'blur' }] }"
      >
        <el-form-item prop="reason">
          <el-input
            type="textarea"
            rows="4"
            maxlength="100"
            show-word-limit
            placeholder="请输入"
            v-model="rejectForm.reason"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div>
          <el-button size="small" @click="rejectDialogVisible = false">取消</el-button>
          <el-button type="primary" size="small" @click="confirmReject">提交</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import contactStore from '@/components/global/contactStore/contactStore';
import Fetch from '@/api';
import Constant from '@/lib/constant';
const baseRole = Constant.RoleList;
export default {
  name: 'approveFooter',
  components: {
    contactStore
  },
  props: {
    prescription: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rejectDialogVisible: false,
      rejectForm: {
        reason: ''
      }
    };
  },
  computed: {
    is_remote_trial_pharmacist() {
      //远程药师特有功能
      const { roles } = this.$store.state.permission;
      console.log(roles, 'roles');

      if (roles.includes(baseRole.remote_trial_pharmacist)) {
        return true;
      }
    }
  },
  methods: {
    async pass() {
      const preCheckPass = await this.pharmacistAuditPreCheck({ id: this.prescription.id });
      if (!preCheckPass) {
        return;
      }

      if (this.is_remote_trial_pharmacist) {
        try {
          await Fetch.verifyPrescription({
            accept: true,
            id: this.prescription.id
          });
          this.$message.success('审核通过');
          this.$emit('nextPrescription');
        } catch (e) {}
      } else {
        this.$confirm('是否确定通过本次处方', '通过处方', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          customClass: 'confirm',
          center: true
        })
          .then(async () => {
            await Fetch.verifyPrescription({
              accept: true,
              id: this.prescription.id
            });
            this.$message.success('审核通过');
            this.$emit('refresh');
            this.$emit('next', this.prescription.id);
          })
          .catch(() => {});
      }
    },
    async reject() {
      const preCheckPass = await this.pharmacistAuditPreCheck({ id: this.prescription.id });
      if (!preCheckPass) {
        return;
      }

      this.rejectDialogVisible = true;
    },
    getPharmacistAuditPreCheckAlertConfig(code, isBatch) {
      const alertConfigMap = {
        PRACTICE_CATEGORY_EMPTY: {
          title: '无法审方',
          message: '您的药师执业类别尚未设置，暂无法审方。请联系店长或公司负责人处理。'
        },
        PRACTICE_CATEGORY_MISMATCH: isBatch
          ? {
              title: '无法批量处理',
              message:
                '根据政策要求，药师仅可审核其执业类别范围内的处方。所选处方中存在不在您执业范围内的处方，暂无法批量处理。'
            }
          : {
              title: '无法审方',
              message: '据政策要求，药师仅可审核其执业类别范围内的处方。当前处方不在您的执业范围内，暂无法审方。'
            }
      };
      return (
        alertConfigMap[code] || {
          title: isBatch ? '无法批量处理' : '无法审方',
          message: isBatch
            ? '根据政策要求，药师仅可审核其执业类别范围内的处方。所选处方中存在不在您执业范围内的处方，暂无法批量处理。'
            : '据政策要求，药师仅可审核其执业类别范围内的处方。当前处方不在您的执业范围内，暂无法审方。'
        }
      );
    },
    async pharmacistAuditPreCheck(params, options = {}) {
      const { code } = await Fetch.pharmacist_audit_pre_check(params);
      if (code) {
        const { title, message } = this.getPharmacistAuditPreCheckAlertConfig(code, options.isBatch);
        await this.$alert(message, title, {
          confirmButtonText: '我知道了',
          customClass: 'warn',
          center: true
        });
        return false;
      }
      return true;
    },
    confirmReject() {
      this.$refs.rejectForm.validate(async valid => {
        if (valid) {
          await Fetch.verifyPrescription({
            accept: false,
            prescriptionRemark: this.rejectForm.reason,
            id: this.prescription.id
          });

          this.rejectDialogVisible = false;
          if (this.is_remote_trial_pharmacist) {
            this.$emit('nextPrescription');
          } else {
            this.$emit('refresh');
          }
        }
      });
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.rejectForm.resetFields();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-top: 1px solid #efefef;
}

.reject-dialog {
  /deep/.el-dialog {
    border-radius: unset;
  }

  /deep/.el-dialog__header {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    height: 56px;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 1px;
      background-color: #eee;
    }

    .el-dialog__title {
      font-size: 16px;
    }

    .el-dialog__headerbtn {
      position: unset;
      display: unset;
    }
  }

  /deep/.el-dialog__body {
    position: relative;
    padding: 24px 24px 0 24px;
  }

  /deep/.el-dialog__footer {
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 24px;
    height: 52px;

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 1px;
      background-color: #eee;
    }

    .el-button {
      width: unset;
      height: unset;
      &.el-button--default {
        background-color: unset;
        border: 1px solid #dcdfe6;
      }
    }
  }
}
</style>
